/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-no-constructed-context-values */
import {
  createContext, useContext, useState, useEffect
} from 'react';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  // Initialisation plus robuste de l'état d'authentification
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    const token = localStorage.getItem('token');
    const isValid = !!token;
    console.log('AuthProvider: Initialisation avec token:', { present: isValid });
    return isValid;
  });

  // Fonction pour gérer la connexion
  const login = (token) => {
    console.log('AuthProvider: Connexion avec token:', { tokenPresent: !!token });
    localStorage.setItem('token', token);
    setIsLoggedIn(true);
  };

  // Fonction pour gérer la déconnexion
  const logout = () => {
    console.log('AuthProvider: Déconnexion');
    localStorage.removeItem('token');
    localStorage.removeItem('userId'); // Suppression de 'userId' si présent
    setIsLoggedIn(false);
  };

  // Fonction pour vérifier si le token est encore valide
  const checkTokenValidity = () => {
    const token = localStorage.getItem('token');
    if (!token) {
      console.log('AuthProvider: Pas de token trouvé');
      setIsLoggedIn(false);
      return false;
    }

    try {
      // Décode le payload du JWT pour vérifier l'expiration
      const payload = JSON.parse(atob(token.split('.')[1]));
      const currentTime = Date.now() / 1000;

      if (payload.exp < currentTime) {
        console.log('AuthProvider: Token expiré');
        logout();
        return false;
      }

      console.log('AuthProvider: Token valide');
      return true;
    }
    catch (error) {
      console.error('AuthProvider: Erreur lors de la vérification du token:', error);
      logout();
      return false;
    }
  };

  // Écouter les changements dans localStorage (pour synchroniser entre onglets)
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === 'token') {
        const hasToken = !!e.newValue;
        console.log('AuthProvider: Changement de token détecté:', { hasToken, newValue: e.newValue ? '***' : null });
        setIsLoggedIn(hasToken);
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  // Vérification automatique du token au démarrage
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      console.log('AuthProvider: Vérification automatique du token au démarrage');
      const isValid = checkTokenValidity();
      if (!isValid) {
        console.log('AuthProvider: Token invalide détecté au démarrage');
      }
    }
  }, []); // Exécuté une seule fois au montage

  return (
    <AuthContext.Provider value={{
      isLoggedIn,
      login,
      logout,
      checkTokenValidity
    }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
